import styled from 'styled-components';

export const ComponentContainer = styled.div`
    background: var(--background-paper-elevation-2);
    color: var(--text-primary);
    border-radius: 4px;
    box-shadow: var(--elevation-100);
    flex-basis: 20%;
`;
